import { CheckoutBuilderComponentTypes, CheckoutBuilderDeviceTypes } from '../constants';

export const GENERIC_SAVE_ERROR = 'Erro ao salvar checkout!';

// O `updateCheckoutService` embrulha o erro no `AppError`, que não guarda o `response`: o corpo
// do 400 só chega aqui achatado em `fieldErrors`. O CheckoutSerializer (CKTPC-1601) aninha a
// recusa sob `config` com a chave `<device>.extra.<componente>.attributes.<campo>`, e o
// achatamento a devolve como "<chave>: <mensagem>", com a mensagem em string ou em lista.
const CONFIG_FIELD_ERROR = /^(desktop|mobile)\.extra\.([^.]+)\.attributes\.[^:]+: ([\s\S]+)$/;

// Nome do catálogo, o mesmo que o erro de yup do `collectBuilderErrors` mostra no mesmo save.
// `hasOwnProperty` porque a chave vem do servidor: `constructor` acharia o do `Object.prototype`.
const catalogName = (catalog, key) =>
  Object.prototype.hasOwnProperty.call(catalog, key) ? catalog[key].name : key;

const describeConfigError = (text) => {
  const [, device, component, message] = CONFIG_FIELD_ERROR.exec(text) || [];

  if (!message) {
    return null;
  }

  const componentName = catalogName(CheckoutBuilderComponentTypes, component);
  const deviceName = catalogName(CheckoutBuilderDeviceTypes, device);

  return `${componentName} (${deviceName}): ${message}`;
};

const readFieldErrors = (error) =>
  (Array.isArray(error?.fieldErrors) ? error.fieldErrors : []).filter(
    (item) => item && Array.isArray(item.errors)
  );

/**
 * Toast do save recusado no builder, no formato `notify.error(message, { subtitle })`. Só a
 * recusa por campo do `config` ganha detalhe; qualquer outra falha (outro 400, 5xx, rede) mantém
 * o texto genérico, sem subtítulo.
 */
export const buildSaveErrorToast = (error) => {
  const lines = readFieldErrors(error).flatMap(({ field, errors }) =>
    errors.map((text) => {
      if (field !== 'config') {
        return { recognized: false, text: `${field}: ${text}` };
      }

      const described = describeConfigError(text);
      return { recognized: Boolean(described), text: described || text };
    })
  );

  // Sem nenhuma recusa reconhecida, não há rótulo confiável para mostrar e o toast fica genérico.
  // Com uma, as outras recusas do mesmo 400 vão junto: omiti-las deixaria o toast parecer completo,
  // e o produtor só as descobriria no save seguinte.
  if (!lines.some(({ recognized }) => recognized)) {
    return { message: GENERIC_SAVE_ERROR };
  }

  // Uma recusa por linha: o subtítulo do `useNotify` renderiza com `white-space: pre-line`.
  return { message: GENERIC_SAVE_ERROR, subtitle: lines.map(({ text }) => text).join('\n') };
};
